import { parseJson } from "../parsers/jsonParser";
import { parseXml } from "../parsers/xmlParser";
import { parseHtml } from "../parsers/htmlParser";
import { parseForm } from "../parsers/formParser";
import { BodyContentType } from "../constants/restRequestConstants";
import { flattenObject } from "./flattenUtils";


export function parseAndProcessResponse(response, options = { flatten: false }) {

	if (response.isBinary) {
		return [{
			path: '$',
			value: '[File]',
			type: 'file',
			meta: {
				binary: true,
				size: response.size,
				filename: response.filename,
				fileExtension: response.fileExtension,
				contentType: response.contentType,
			}
		}];
	}

	const parsed = parseByContentType(response.data, response.contentType);

	// if (options.flatten) {
	//   return flattenObject(parsed, {
	//     ...DEFAULT_LIMITS,
	//     ...(options.limits || {})
	//   });
	// }

	if (options.flatten) {
		return flattenObject(parsed);
	}

	return [{
		path: "$",
		value: parsed,
		type: typeof parsed
	}];
}

export function parseByContentType(data, contentType = "") {

	if (contentType.includes(BodyContentType.JSON)) {
		return parseJson(data);
	}
	if (contentType.includes(BodyContentType.XML)) {
		return parseXml(data);
	}
	if (contentType.includes(BodyContentType.HTML)) {
		return parseHtml(data);
	}
	if (contentType.includes(BodyContentType.FORM)) {
		return parseForm(data);
	}
	return data;
}
